import { render, staticRenderFns } from "./InprocessTrainings.vue?vue&type=template&id=2e8cba44&scoped=true"
import script from "./InprocessTrainings.vue?vue&type=script&lang=js"
export * from "./InprocessTrainings.vue?vue&type=script&lang=js"
import style0 from "./InprocessTrainings.vue?vue&type=style&index=0&id=2e8cba44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8cba44",
  null
  
)

export default component.exports